import { render, staticRenderFns } from "./OpportunityPage.vue?vue&type=template&id=71c8dcf8&scoped=true&"
import script from "./OpportunityPage.vue?vue&type=script&lang=js&"
export * from "./OpportunityPage.vue?vue&type=script&lang=js&"
import style0 from "./OpportunityPage.vue?vue&type=style&index=0&id=71c8dcf8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c8dcf8",
  null
  
)

export default component.exports